var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOMcreateElement, DOMcreateFragment } from '../typescript/TSXDomParse';
import ConditionalWrapper from './ConditionalWrapper';
export default function NavLink(props) {
    var _a;
    var trigger = props.trigger, text = props.text, url = props.url, type = props.type;
    var expandable = props.expandable, wrapInSpan = props.wrapInSpan;
    if (!expandable)
        expandable = false;
    if (!wrapInSpan)
        wrapInSpan = false;
    var hasLink = ((_a = url === null || url === void 0 ? void 0 : url.length) !== null && _a !== void 0 ? _a : 0) > 0;
    var className = "nav-link level-" + props.level + " nav-link-" + type;
    if (props.className)
        className += " " + props.className;
    if (hasLink)
        className += ' has-link';
    return (DOMcreateElement("a", __assign({}, (props.onClick ? { onClick: props.onClick } : {}), (hasLink ? { href: url } : {}), (trigger ? { dataTrigger: trigger } : {}), { className: className }),
        DOMcreateElement(ConditionalWrapper, { condition: wrapInSpan, wrapper: function (children) { return DOMcreateElement("span", null, children); } },
            DOMcreateElement(DOMcreateFragment, null, text)),
        DOMcreateElement(DOMcreateFragment, null, expandable ? DOMcreateElement("span", { className: "nav-link__caret" }) : '')));
}
